import 'styled-components/macro';
import { Button, Typography, useTheme } from '@harver/shared-ui';
import React from 'react';

import { useContent } from '../../../../branding/content.context';
import CookieBanner from '../../../../components/CookieBanner';

const TooManyRequests = (): JSX.Element => {
    const theme = useTheme();
    const { openInviteTooManyRequests: LANG } = useContent();
    document.title = LANG.browserTitle;

    return (
        <>
            <div
                css={{
                    padding: `${theme.sizes.xLarge} ${theme.sizes.xxLarge}`,
                    textAlign: 'center',
                }}
                data-testid="openInvite.tooManyRequests"
            >
                <div css={{ marginBottom: theme.sizes.large }}>
                    <Typography css={{ marginBottom: theme.sizes.xSmall }} variant="h3">
                        {LANG.title}
                    </Typography>
                    <Typography color="neutral.600" variant="body1" css={{ whiteSpace: 'pre-line' }}>
                        {LANG.p1}
                    </Typography>
                </div>
                <Button
                    color="primary"
                    onClick={() => window.location.reload()}
                    testId="openInvite.tooManyRequests.reloadButton"
                >
                    {LANG.button}
                </Button>
            </div>
            <CookieBanner />
        </>
    );
};

export default TooManyRequests;
